<section>
  <app-form-header (onCancel)="cancel()"></app-form-header>
  @if (form) {
  <form [formGroup]="form" class="astral-content-width astral-stack-l" (ngSubmit)="onSubmit()">
      <section class="astral-section-surface astral-form-stack">
        <astral-layout-group [columns]="5" [tabletColumns]="2" [mobileColumns]="1">
          <astral-input [control]="form.controls['statusCaption']" [translateValue]="true"></astral-input>
          <astral-input [control]="form.controls['emailaddress']" [type]="'email'"></astral-input>
          <astral-input [control]="form.controls['createdDateTime']"></astral-input>
          <astral-input [control]="form.controls['sentDateTime']"></astral-input>
          <astral-input [label]="'LOG.USERNAME' | translate" [value]="dataContext.createdBy" [readonly]="true"></astral-input>
          <astral-input [control]="form.controls['subject']" [span]="'full'"></astral-input>
        </astral-layout-group>
        <astral-textarea [control]="form.controls['body']" [rows]="12"></astral-textarea>
      </section>
      @if (savedAttachments.controls.length > 0) {
        <section class="astral-section-surface astral-stack-s">
          <h4>{{ 'COMMON.ATTACHED_FILES' | translate }}</h4>
          @for (attachment of $any(savedAttachments.controls); track attachment) {
            <div>
              <astral-button type="button" variant="secondary" icon="file" [label]="attachment.controls['originalName'].value" (click)="downloadAttachment(attachment.controls['id'].value)"></astral-button>
            </div>
          }
        </section>
      }
    </form>
  }
</section>
